import { combineReducers } from 'redux'
import facebook from './facebook'

export default combineReducers({ facebook })
